<template>
  <hm-content title>
    <div class="flex flex-center">
      <div class="w50 mr10">
        <div>
          <div class="title">积分过期规则</div>
          <el-form
            ref="ruleForms"
            :model="ruleForms"
            :rules="rules"
            label-width="120px"
          >
            <el-form-item label="过期周期" prop="overdueValue">
              <div class="xxx">
                <el-input
                  clearable
                  style="width:100px"
                  v-model="ruleForms.overdueValue"
                  maxlength="20"
                  size="small"
                ></el-input
                >天
              </div>

              <!-- <div class="form-item-tip">
            编号为唯一值，仅支持英文和数字，不支持其他符号
          </div> -->
            </el-form-item>
          </el-form>
          <!-- <div class="zhouqi">
            过期周期
            <el-input
              clearable
              v-model.trim="keyWords"
              placeholder="输入周期"
              size="small"
              class="ipt mr10"
            ></el-input
            >天
          </div> -->
          <div class="explain form-item-tip">
            设置说明:积分过期采用 <span class="primary">周期滚动扣减</span>
            的模式。周期计算的起始日期为合伙人用户第一次获得积分的日期。扣减周期代表从起始日期开始到周期
            结束日的次日扣减该周期区间以前的未使用积分，且每天滚动扣减周期前一天积分。
          </div>
          <div class="example form-item-tip">
            例如：
            扣减周期为30天，第一次获得积15分为1月1日，1月2日获得18积分，1月3日获得20积分。则在1月31日前如果消耗了10积分，则2月1
            日扣减积分为15-10=5积分，2月2日扣减1月2日获得的18积分。
          </div>
          <div class="btn flex flex-center">
            <el-button size="small" type="primary" @click="save()"
              >确定修改</el-button
            >
          </div>
        </div>
      </div>
      <div class="w50">
        <div class="info-list">
          操作日志
        </div>
        <div class="table">
          <el-table
            stripe
            border
            ref="table"
            :data="list"
            style="width: 100%"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="operateName"
              label="操作人"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="操作结果"
            >
              <template slot-scope="scope">
                <div class="blue">
                  {{
                    scope.row.afterDataValue - scope.row.beforeDataValue < 0
                      ? "扣减"
                      : "增加"
                  }}{{ status === "integral_period_days" ? "周期" : "有效期"
                  }}{{
                    Math.abs(
                      scope.row.afterDataValue - scope.row.beforeDataValue
                    )
                  }}日
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div class="hm-pagination">
            <el-pagination
              background
              :total="total"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPage"
            ></el-pagination>
          </div> -->
        </div>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      show: false,
      showIcon: false,
      status: "integral_period_days",
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      keyWords: "",
      ruleForms: {
        overdueValue: ""
      },
      rules: {
        overdueValue: [
          {
            required: true,
            trrger: "blur",
            message: "请输入天数"
          },
          {
            message: "请输入正整数",
            pattern: /^[1-9]\d*$/
          }
        ]
      },
      ruleForm: {
        itemValue: "",
        growthBgpImg: "",
        growthName: "",
        growthValue: "",
        growthIcon: ""
      },
      rule: {
        itemValue: [
          {
            required: true,
            trrger: "blur",
            message: "请输入天数"
          },
          {
            message: "请输入正整数",
            pattern: /^[1-9]\d*$/
          }
        ],
        growthName: {
          required: true,
          trrger: "blur",
          message: "请输入等级名称"
        },
        growthValue: [
          {
            required: true,
            trrger: "blur",
            message: "请输入等级名称"
          },
          {
            message: "请输入正整数",
            pattern: /^[1-9]\d*$/
          }
        ],
        growthIcon: {
          required: true,
          trrger: "blur",
          message: "请上传图标"
        }
      },
      levelList: [],
      ruleId: ""
    };
  },
  computed: mapGetters(["detailsIntegralGrowth"]),
  watch: {},
  created() {},
  mounted() {
    this.queryDetails();
  },
  methods: {
    cropUploadSuccess(jsonData) {
      this.ruleForm.growthBgpImg = jsonData.result;
    },
    cropUploadSuccessIcon(jsonData) {
      this.ruleForm.growthIcon = jsonData.result;
    },
    switchTab() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.queryDetails();
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryIntegralOverdueRule");
      const { overdueValue, logList } = result;
      this.ruleForms.overdueValue = overdueValue ? overdueValue : "";
      if (logList.length) {
        this.list = logList;
      }
    },
    async queryList(ruleId) {
      this.ruleId = ruleId;
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ruleId: ruleId
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // searchCondition.startTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[0]
      //     : "";
      // searchCondition.endTime =
      //   this.searchCondition.applyDate &&
      //   this.searchCondition.applyDate.length > 0
      //     ? this.searchCondition.applyDate[1]
      //     : "";
      // Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryFindLogList", params);
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList(this.ruleId);
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList(this.ruleId);
    },
    add() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const searchCondition = JSON.parse(JSON.stringify(this.ruleForm));
          this.levelList.push(searchCondition);
        } else {
          return false;
        }
      });
    },
    remove(i, row) {
      if (row.growthId) {
        this.$store
          .dispatch("delIntegralGrowth", { growthId: row.growthId })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功！",
                type: "success"
              });
              this.queryDetails();
              this.status = "growth_period_days";
            }
          });
      } else {
        this.levelList.splice(i, 1);
      }
    },
    save() {
      this.$refs.ruleForms.validate(valid => {
        if (valid) {
          this.$store
            .dispatch("saveIntegralOverdueRule", {
              overdueValue: this.ruleForms.overdueValue
            })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功！",
                  type: "success"
                });
                this.queryDetails();
              }
            });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.xxx {
  .el-input__inner {
    border-top: 0px;
    border-left: 0px;
    border-right: 0px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
</style>
<style lang="scss" scoped>
.w50 {
  width: 50%;
}
.title {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(34, 34, 34, 1);
}
.zhouqi {
  margin-top: 30px;
  height: 14px;
  font-size: 14px;
}
.explain {
  margin-top: 50px;
}
.example {
  margin-top: 20px;
}
.btns {
  margin-top: 5rem;
  height: 33px;
}
.info-list {
  margin-bottom: 20px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.logo {
  width: 80px;
}
</style>
